import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AppSections from "../utils/AppSections";
import TextureAddEdit from "../ui/textures/TextureAddEdit";
import Textures from "../ui/textures/Textures";
import TextureDetails from "../ui/textures/TextureDetails";

const TexturesRoutes = (
  <Route
    path={AppSections.TEXTURES}
    element={
      <ProtectedRoute>
        <Textures />
      </ProtectedRoute>
    }
  >
    <Route path=":id/view" element={<TextureDetails />} />
    <Route path=":id/edit" element={<TextureAddEdit />} />
  </Route>
);

export default TexturesRoutes;
